<template>
    <div class="odd-labels">
        <div class="sp" v-if="ou.market == 2208 || ou.market == 623">
            {{ ou.hcpi }}
        </div>
      <div class="sp" v-else>
        {{ ou.hcp }}
      </div>
        <div v-for="odd in ou.odd">
            <Selection :selectedOdds="selectedOdds" :odd="odd" :match="match" :market="ou"></Selection>
        </div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'
    import Selection from "./selection";

    export default {
        name: 'handicap',
        components: {Selection},
        mixins: [betSlip],
        props: {
            market: {
                type: Number,
                default: 8
            },
            odds: {},
            match: {},
            selectedOdds: {}
        },
        data() {
            return {
                ouDefault: {"id":"7287167","name":"","disabled":false,"closed":false,"sp":".","hcp":"","market":4477,"markets":[17,1],"column":2,"layout":3,"order":7,"odd":{"1":{"id":14751718,"oddType":4477,"outcome":"1","odd":"1.85","sp":"0.00","live":true,"active":false,"order":1,"change":0,"r":"Waiting","resultId":1},"2":{"id":14751717,"oddType":4477,"outcome":"2","odd":"1.85","sp":"0.00","live":true,"active":false,"order":2,"change":0,"r":"Waiting","resultId":1}}},
                ou: {"id":"7287167","name":"","disabled":false,"closed":false,"sp":".","hcp":"","market":4477,"markets":[17,1],"column":2,"layout":3,"order":7,"odd":{"1":{"id":14751718,"oddType":4477,"outcome":"1","odd":"1.85","sp":"0.00","live":true,"active":false,"order":1,"change":0,"r":"Waiting","resultId":1},"2":{"id":14751717,"oddType":4477,"outcome":"2","odd":"1.85","sp":"0.00","live":true,"active":false,"order":2,"change":0,"r":"Waiting","resultId":1}}},
                t: this.$root.t,
                markets: [
                    -2950, -2560, 209, -2580, -2978, -2580, -9004, -458, 2208, 623, -2581, -2572, 8692, 8940, 6549, 4477, 5492, 8692
                ],
                virtualOdds: []
            }
        },
        watch: {
            odds: {
                handler() {
                    this.virtualOdds = Object.values(this.odds);
                    this.checkSpecialValue();
                },
                deep: true
            }
        },
        mounted() {

            if(this.odds){
                this.virtualOdds = Object.values(this.odds);
            }


            this.checkSpecialValue();

        },
        methods: {
            checkSpecialValue() {
                this.ou = this.ouDefault;

                var ag = 0;
                Object.keys(this.virtualOdds).forEach((key) => {
                    var sp = parseFloat(this.virtualOdds [key].sp);
                    if (this.markets.indexOf(this.virtualOdds [key].market) !== -1 && sp % 1 !== 0 && sp !== 'null' && !this.virtualOdds [key].closed) {
                        Object.values(this.virtualOdds[key].odd).forEach((v) => {
                            var oddn = parseFloat(v.odd);
                            ag = (oddn + ag);
                        });
                        if (ag <= 4.20)
                            this.ou = this.virtualOdds [key];
                        ag = 0;
                    }
                });
            },
            fetchSelectedBets() {

                this.$getItem('bets', function (key, value) {
                    self.selectedOdds = value;
                }, function (err) {
                    self.updateBets([])
                })
            },
        }
    }
</script>

<style scoped>
    .odd-labels {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .odd-labels div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex: 1;
        font-weight: bold;
        font-size: 11px
    }

    .sp {
        background: none !important;
        color: #000;
        font-weight: lighter;
        font-size: 11px;
    }
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/handicap.vue